// Copyright © 2021 Move Closer

import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapButton, BootstrapIcon } from '../../../../dsl/front'

/**
 * @emits click
 *
 * @author Sebastian Dziechciarz, Stanisław Gregor
 */
@Component({
  name: 'ArticleSocial',
  components: { BootstrapButton, BootstrapIcon },

  template: `
    <BootstrapButton class="article-social btn-secondary btn-small btn-square" @click="onClick">
      <BootstrapIcon :name="mappedIcon" size="medium" />
    </BootstrapButton>
  `
})
export class ArticleSocial extends Vue {
  /**
   * The icon (its name) that is to be rendered inside the `<button>`.
   */
  @Prop({ type: String, required: true })
  private readonly icon!: string

  public get mappedIcon (): string {
    if (this.icon === 'twitter') {
      return 'x'
    }

    return this.icon
  }

  /**
   * Handles `@click` event on the `<button>`.
   */
  public onClick (): void {
    this.$emit('click')
  }
}

export default ArticleSocial
